module.exports = __webpack_public_path__ + "static/media/loss-of-work-fitness-insurance-card-img.218f9d51.png";